window.header = {
    $header: null,
    $langNavWrapper: null,
    $mainNavWrapper: null,
    $headerSearch: null,

    /**
     * Initialization of all Elements the Page
     */
    init: function() {
        this.$header = document.querySelector(".header");
        this.initLanguageNav();
        this.initMainNav();
        this.initSearch();
    },

    /**
     * Initialization of Language Javascript if Language Wrapper exists
     */
    initLanguageNav: function() {
        if(this.$header.querySelector(".cell--language .language__menu")) {
            this.$langNavWrapper = this.$header.querySelector(".cell--language");
            window.language.init(this.$langNavWrapper);
        }
    },

    /**
     * Initialization of MainNavigation Javascript if MainNavigation Wrapper exists
     */
    initMainNav: function() {
        if(this.$header.querySelector(".cell--nav .header__nav")) {
            this.$mainNavWrapper = this.$header.querySelector(".cell--nav");
            window.mainNavigation.init(this.$mainNavWrapper);
        }
    },

    /**
     * Initialization of Header Search Javascript if Header Search Wrapper exists
     */
    initSearch: function() {
        if(this.$header.querySelector(".header__search")) {
            this.$headerSearch = this.$header.querySelector(".header__search");
            var $headerSearchIcon = this.$headerSearch.querySelector("span.icon-search"),
                $headerSearchBtnMobile = this.$header.querySelector(".cell--search-btn"),
                $headerCellSearch = this.$header.querySelector(".cell--search");

            $headerSearchIcon.addEventListener('click',function(){
                window.header.$headerSearch.submit();
            });

            $headerSearchBtnMobile.addEventListener('click',function(){
                $headerCellSearch.classList.toggle("cell--search--active");
            });
        }
    }
};
